import { render, staticRenderFns } from "./statut-livraison-chip.vue?vue&type=template&id=a4ed0794&scoped=true"
import script from "./statut-livraison-chip.vue?vue&type=script&lang=js"
export * from "./statut-livraison-chip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ed0794",
  null
  
)

export default component.exports